import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import LiveBanner from "@/components/LiveBanner";
import Home from "@/pages/Home";
import Programs from "@/pages/Programs";
import ProgramDetail from "@/pages/ProgramDetail";
import Apply from "@/pages/Apply";
import ApplyThankYou from "@/pages/ApplyThankYou";
import Assistant from "@/pages/Assistant";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import University from "@/pages/University";
import CourseDetail from "@/pages/CourseDetail";
import Media from "@/pages/Media";
import Membership from "@/pages/Membership";
import Events from "@/pages/Events";
import Careers from "@/pages/Careers";
import Investors from "@/pages/Investors";
import Foundation from "@/pages/Foundation";
import Shop from "@/pages/Shop";
import Bookstore from "@/pages/Bookstore";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import FounderQA from "@/pages/FounderQA";
import FounderWall from "@/pages/FounderWall";
import Admin from "@/pages/Admin";
import Livestream from "@/pages/Livestream";
import SponsorDogs from "@/pages/SponsorDogs";
import SponsorDogDetail from "@/pages/SponsorDogDetail";
import Alumni from "@/pages/Alumni";
import AlumniDetail from "@/pages/AlumniDetail";
import AlumniJoin from "@/pages/AlumniJoin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function Shell() {
  const location = useLocation();
  // If OAuth callback session_id is present in URL fragment on any route, hand off to AuthCallback
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Navbar />
      <LiveBanner />
      <ScrollToTop />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/programs/:slug" element={<ProgramDetail />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/apply/thank-you" element={<ApplyThankYou />} />
          <Route path="/assistant" element={<Assistant />} />
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/university" element={<University />} />
          <Route path="/university/:id" element={<CourseDetail />} />
          <Route path="/media" element={<Media />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/events" element={<Events />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/investors" element={<Investors />} />
          <Route path="/foundation" element={<Foundation />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/bookstore" element={<Bookstore />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/founder-qa" element={<FounderQA />} />
          <Route path="/wall" element={<FounderWall />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/livestream" element={<Livestream />} />
          <Route path="/foundation/dogs" element={<SponsorDogs />} />
          <Route path="/foundation/dogs/:id" element={<SponsorDogDetail />} />
          <Route path="/alumni" element={<Alumni />} />
          <Route path="/alumni/join" element={<AlumniJoin />} />
          <Route path="/alumni/:id" element={<AlumniDetail />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Shell />
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#141414",
                color: "#f9f6f0",
                border: "1px solid rgba(212,175,55,0.35)",
              },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
